module.exports = '<svg width="34" height="32" viewBox="0 0 34 32"><path d="M30.067 2.148v.41l-28.37 6.08A2.148 2.148 0 0 0 0 10.738v6.443c0 1.014.707 1.888 1.697 2.1l4.746 1.016v9.77c0 1.188.96 1.933 2.148 1.933h10.738c1.188 0 2.148-.747 2.148-1.933v-6.548l8.591 1.841v.412c0 1.188.96 2.148 2.148 2.148s2.148-.96 2.148-2.148V2.148C34.364.96 33.404 0 32.216 0s-2.148.96-2.148 2.148zM10.738 27.705v-6.486l6.443 1.381v5.105h-6.443z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/megaphone-1.js
// module id = 1267
// module chunks = 14